<spinner *ngIf="loading"></spinner>
<h5 class="mt-2 mb-4 fw-bold">Account information</h5>

<div class="row mb-3 ps-4">
    <div class="col-md-6">
        <p class="mb-1"><span class="fw-bold">Team:</span> {{ patient?.department.name }}</p>
        <p class="mb-1"><span class="fw-bold">Type of user:</span> {{ typeOfUser }}</p>
        <p class="mb-1"><span class="fw-bold">Feature set:</span> {{ patient?.user.activeLicense.license.name }}</p>
    </div>
    <div class="col-md-6">
    </div>
</div>

<h5 class="mt-5 mb-4 fw-bold">Personal details</h5>

@if (['Patient', 'Patient and carer'].includes(typeOfUser)) {
    <h6 class="mt-2 mb-4 fw-bold">Patient Information</h6>

    <div class="row mb-3 ps-4">
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">First name:</span> {{ patient.user.firstName }}</p>
            <p class="mb-1"><span class="fw-bold">Date of birth:</span> {{ patient.dateOfBirth | date }}</p>
            <p class="mb-1"><span class="fw-bold">Sex at birth:</span> {{ patient.biologicalSex }}</p>
            <p class="mb-1"><span class="fw-bold">Mobile phone number:</span> {{ patient.user.phoneNumber }}</p>
            <p class="mb-1"><span class="fw-bold">NHS number:</span> {{ patient.nhsNumber }}</p>
            <p class="mb-1"><span class="fw-bold">Weight (Kg):</span> {{ patient.weight }}</p>
        </div>
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">Last name:</span> {{ patient.user.lastName }}</p>
            <p class="mb-1"><span class="fw-bold">Age:</span> {{ patient.age }}</p>
            <p class="mb-1">&nbsp;</p>
            <p class="mb-1"><span class="fw-bold">Email:</span> {{ patient.user.email }}</p>
            <p class="mb-1">&nbsp;</p>
            <p class="mb-1"><span class="fw-bold">Height (cm):</span> {{ patient.height }}</p>
        </div>
    </div>
}

@if (['Carer', 'Patient and carer'].includes(typeOfUser)) {
    <h6 class="mt-2 mb-4 fw-bold">Carer Information</h6>

    <div class="row mb-3 ps-4">
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">First name:</span> {{ patient.carer.user.firstName }}</p>
            <p class="mb-1"><span class="fw-bold">Mobile phone number:</span> {{ patient.carer.user.phoneNumber }}</p>
            <p class="mb-1"><span class="fw-bold">Relation to patient:</span> {{ patient.carerRelationship.name }}</p>
        </div>
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">Last name:</span> {{ patient.carer.user.lastName }}</p>
            <p class="mb-1"><span class="fw-bold">Email:</span> {{ patient.carer.user.email }}</p>
        </div>
    </div>
}

@if (showChildSection) {
    <h6 class="mt-2 mb-4 fw-bold">Your child</h6>

    <div class="row mb-3 ps-4">
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">First name:</span> {{ childNameHidden ? 'Hidden for privacy' : childPatient?.user?.firstName }}</p>
            <p class="mb-1"><span class="fw-bold">Date of birth:</span> {{ childPatient?.dateOfBirth | date }}</p>
        </div>
        <div class="col-md-6">
            <p class="mb-1"><span class="fw-bold">Age:</span> {{ childPatient?.age }}</p>
        </div>
    </div>
}

<h5 class="mt-5 mb-4 fw-bold">ED AND co-morbidities</h5>
<div class="ps-4">
    <questionnaire-form [disabled]="true"></questionnaire-form>
</div>

<h5 class="mt-5 mb-4 fw-bold">Care programme</h5>

<div class="row">
    <div class="col-md-6" *ngIf="['Patient', 'Patient and carer'].includes(typeOfUser)">
        <h6 class="mt-2 mb-4 fw-bold">Patient Care Programme</h6>
        <patient-registration-confirmation-care-programme #patientCareProgram></patient-registration-confirmation-care-programme>
    </div>
    <div class="col-md-6" *ngIf="['Carer', 'Patient and carer'].includes(typeOfUser)">
        <h6 class="mt-2 mb-4 fw-bold">Carer Care Programme</h6>
        <patient-registration-confirmation-care-programme #carerCareProgram></patient-registration-confirmation-care-programme>
    </div>
</div>
